import { useAppSelector } from '../app/hooks';

export function useCanViewAllCompanies(): boolean {
  const { canViewAllCompanies, isSuperuser } = useAppSelector(
    (state) => state.user.user
  );

  return canViewAllCompanies ?? Boolean(isSuperuser);
}
